import apiGraph from "@/helpers/api/apiGraph";

export const group_state = {
  isMemberOfGroupMap: {},
  isOwnerOfGroupMap: {}
};

export const group_actions = {
  isMemberOfGroup(userId, groupId, isMember) {
    if (!this.isMemberOfGroupMap[userId]) {
      this.isMemberOfGroupMap[userId] = {};
    }
    this.isMemberOfGroupMap[userId][groupId] = isMember;
  },

  isOwnerOfGroup(userId, groupId, isOwner) {
    if (!this.isOwnerOfGroupMap[userId]) {
      this.isOwnerOfGroupMap[userId] = {};
    }
    this.isOwnerOfGroupMap[userId][groupId] = isOwner;
  },

  /**
   * Checks if user is member of group in graph
   * @param { string } userId users id (guid)
   * @param { string }groupId groups id (guid)
   * @returns { boolean } true if user is member of group
   */
  async isMembersOfGroup(userId, groupId) {
    if (this.isUserMemberOfGroup({ userId, groupId }) !== undefined) {
      return this.isUserMemberOfGroup({ userId, groupId });
    }

    try {
      let response = await apiGraph.get(`/groups/${groupId}/members`);

      if (response.data.value.some(m => m.id === userId)) {
        this.isMemberOfGroup(userId, groupId, true);
        return true;
      }

      while (response.data && response.data["@odata.nextLink"]) {
        response = await apiGraph.get(response.data["@odata.nextLink"]);

        if (response.data.value.some(m => m.id === userId)) {
          this.isMemberOfGroup(userId, groupId, true);
          return true;
        }
      }
    } catch {
      this.isMemberOfGroup(userId, groupId, false);
      return false;
    }
    this.isMemberOfGroup(userId, groupId, false);
    return false;
  },

  /**
   * Checks if user is owner of group in graph
   * @param { string } userId users id (guid)
   * @param { string } groupId groups id (guid)
   * @returns { boolean } true if user is owner of group
   */
  async isOwnersOfGroup(userId, groupId) {
    if (this.isUserOwnerOfGroup({ userId, groupId }) !== undefined) {
      return this.isUserOwnerOfGroup({ userId, groupId });
    }

    try {
      let response = await apiGraph.get(`/groups/${groupId}/owners`);

      if (response.data.value.some(m => m.id === userId)) {
        this.isOwnerOfGroup(userId, groupId, true);
        return true;
      }

      while (response.data && response.data["@odata.nextLink"]) {
        response = await apiGraph.get(response.data["@odata.nextLink"]);
        if (response.data.value.some(m => m.id === userId)) {
          this.isOwnerOfGroup(userId, groupId, true);
          return true;
        }
      }
    } catch {
      this.isOwnerOfGroup(userId, groupId, false);
      return false;
    }
    this.isOwnerOfGroup(userId, groupId, false);
    return false;
  }
};

export const group_getters = {
  isUserMemberOfGroup: state => (userId, groupId) =>
    state.isMemberOfGroupMap[userId] ? state.isMemberOfGroupMap[userId][groupId] : undefined,

  isUserOwnerOfGroup: state => (userId, groupId) =>
    state.isOwnerOfGroupMap[userId] ? state.isOwnerOfGroupMap[userId][groupId] : undefined
};
